import customModalsReducer from "reducers/customModalsReducer";

import authReducer from "reducers/authReducer";
import actionReducer from "reducers/actionReducer";
import userReducer from "reducers/usersReducer";
import bikeReducer from "reducers/bikeReducer";
import bikeHistoryReducer from "reducers/bikeHistoryReducer";
import tariffReducer from "reducers/tariffReducer";
import packageReducer from "reducers/packageReducer";
import walletReducer from "reducers/walletReducer";
import zoneReducer from "reducers/zoneReducer";
import tagReducer from "reducers/tagReducer";
import aggregationReducer from "reducers/aggregationReducer";
import transactionReducer from "reducers/transactionReducer";
import locationsReducer from "reducers/locations";
import reportsReducer from "reducers/reportsReducer";
import notificationTemplatesReducer from "reducers/notificationTemplatesReducer";
import bikeScanTriggerReducer from "reducers/bikeScanTriggerReducer";
import bikeTriggerHistoryReducer from "reducers/bikeTriggerHistoryReducer";
import festiveDaysReducer from "reducers/festiveDaysReducer";
import sharingReducer from "reducers/sharingReducer";
import phoneCodesReducer from "reducers/phoneCodesReducer";
import promoCodesReducer from "reducers/promoCodesReducer";
import tripActiveReducer from "reducers/tripActiveReducer";

import scooterReducer from "reducers/scooter/scooter/scooterReducer";
import scooterHistoryReducer from "reducers/scooter/scooterHistoryReducer";
import scooterBatteryReducer from "reducers/scooter/scooter/scooterBatteryReducer";
import scooterBatteryHistoryReducer from "reducers/scooter/scooter/scooterBatteryHistoryReducer";
import scooterTripActiveReducer from "reducers/scooter/scooterTripActiveReducer";
import scooterTripReducer from "reducers/scooter/scooterTripReducer";
import billingModeTariffReducer from "reducers/scooter/billingModeTariffReducer";
import scooterZonesReducer from "reducers/scooter/scooterZonesReducer";
import scooterParkingReducer from "reducers/scooter/scooterParkingReducer";

import languageReducer from "reducers/languageReducer";
import messageReducer from "reducers/messageReducer";
import moduleReducer from "reducers/moduleReducer";
import translationReducer from "reducers/translationReducer";

import adminReducer from "reducers/adminReducer";
import newsReducer from "reducers/newsReducer";

import chargerMainReducer from "reducers/chargers/chargerMainReducer";
import chargerStationReducer from "reducers/chargers/chargerStationReducer";
import chargerPackageReducer from "reducers/chargers/packageReducer";
import chargerTariffReducer from "reducers/chargers/tariffReducer";
import powerBankActiveRentReducer from "reducers/chargers/powerBankActiveRentReducer";
import powerBankRentReducer from "reducers/chargers/powerBankRentReducer";

export default {
  customModals: customModalsReducer,

  auth: authReducer,
  action: actionReducer,
  users: userReducer,
  bikeHistory: bikeHistoryReducer,
  bike: bikeReducer,
  bikeScanTrigger: bikeScanTriggerReducer,
  bikeTriggerHistory: bikeTriggerHistoryReducer,
  tariff: tariffReducer,
  package: packageReducer,
  wallet: walletReducer,
  zone: zoneReducer,
  tag: tagReducer,
  aggregation: aggregationReducer,
  transaction: transactionReducer,
  locations: locationsReducer,
  reports: reportsReducer,
  notificationTemplates: notificationTemplatesReducer,
  festiveDays: festiveDaysReducer,
  sharing: sharingReducer,
  phoneCodes: phoneCodesReducer,
  promoCodes: promoCodesReducer,
  tripActive: tripActiveReducer,

  scooter: scooterReducer,
  scooterBattery: scooterBatteryReducer,
  scooterBatteryHistory: scooterBatteryHistoryReducer,
  scooterTripActive: scooterTripActiveReducer,
  scooterTrip: scooterTripReducer,
  scooterHistory: scooterHistoryReducer,
  billingModeTariff: billingModeTariffReducer,
  scooterZones: scooterZonesReducer,
  scooterParking: scooterParkingReducer,

  language: languageReducer,
  message: messageReducer,
  module: moduleReducer,
  translation: translationReducer,

  admin: adminReducer,
  news: newsReducer,

  charger: chargerMainReducer,
  chargerStation: chargerStationReducer,
  chargerPackage: chargerPackageReducer,
  chargerTariff: chargerTariffReducer,
  powerBankActiveRent: powerBankActiveRentReducer,
  powerBankRent: powerBankRentReducer,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js